/**
 * 基础依赖配置
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

/**当前运行环境 */
var envType = 1; //1开发服；2点检服；3演示服；4生产服务；5本地开发机;

var cfg = {
  envType:envType,
  //是否是调试模式
  debug: true,
  //是否要模拟登陆  需要服务APi支持，暂不启用
  autoLogin: false,
  //模拟登陆   账号
  autoLoginInfo: {
    source: '',
    openId: '',
    otId: ''
  },
  //api请求地址
  api: {
    /**开发者ID(AppID) */
    wechat_appId: '',
    /**只是登录时候调用的key */
    api_key: '',
    /**根api */
    api_root: '',
    /**新服务 根api */
    api_root2: '',
    /**http地址 api */
    api_root_http: '',
    /**集成服务 api */
    api_owt: '',
  }
};

//根据不同的环境输出不同的依赖配置
switch (envType) {
  //开发
  case 1:
    // cfg.debug = false;
    cfg.api.api_key = 'YoO45SINRHiOCISOfn3olA0bBvxCPsPf55CwX6FhAbTYM6nhFOa7jDqhMTu8LboKNLT3lD7i038%3D'
    //cfg.api.api_owt = 'http://localhost:8081/suguo'
    //cfg.api.api_owt = 'http://crvweixin.crv.com.cn/sg/einvoice'
    cfg.api.api_owt = 'https://ei.suguo.com.cn/einvoice'
    //cfg.api.api_owt = 'https://einvoiceuat.crv.com.cn/sg'
    break;
  default:
    // cfg.debug = true;
    cfg.api.api_key = 'YoO45SINRHiOCISOfn3olA0bBvxCPsPf55CwX6FhAbTYM6nhFOa7jDqhMTu8LboKNLT3lD7i038%3D'
    cfg.api.api_owt = 'hhttp://wuliu.crvweixin.crv.com.cn/h5'
    break;
}

export default cfg;



// WEBPACK FOOTER //
// ./src/config/base.js